<template>
  <div id="app">
    <Vheader></Vheader>
    <transition name="fade">
      <keep-alive include="overview">
        <router-view :key="$route.path"></router-view>
      </keep-alive>
    </transition>
  </div>
</template>

<script>
import Vheader from '@/components/Header/Vheader'

export default {
  name: 'app',
  components: {
    Vheader
  }
}
</script>

<style lang="scss">
@import "./assets/scss/style.scss";

.fade-enter-active, .fade-leave-active {
  transition-property: opacity;
  transition-duration: .25s;
}

.fade-enter-active {
  transition-delay: .25s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/App.vue